module.exports = __webpack_public_path__ + "static/media/tarot-card-11.65a4d916.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/tarotcards/tarot-card-11.jpg
// module id = 1544
// module chunks = 0